<template>
  <div :class="$style.header">
    <div :class="$style.headerMain">
      <component :is="useH1 ? 'h1' : 'div'" :class="$style.headerLogo">
        <a href="/" aria-label="iichi"><SvgIcon :svg="IichiLogo" width="87" /></a>
      </component>
      <template v-if="!isSimple">
        <div v-if="!isAccount" :class="$style.headerSearch">
          <form action="/listing" :class="$style.headerSearchForm" @submit="onSubmitSearch">
            <input
              v-model="query"
              type="search"
              name="q"
              tabindex="0"
              placeholder="何をお探しですか？"
              :class="$style.headerSearchQuery"
              @click="
                () => {
                  if (isSp) {
                    onClickSearchInputSP();
                  }
                }
              "
            />
            <button type="submit" :class="$style.headerSearchSubmit">
              <SvgIcon :svg="SearchIcon" width="20" aria-label="検索" />
            </button>
          </form>
        </div>
        <HeaderIcons />
      </template>
    </div>
  </div>
  <div v-if="!isSimple && !isAccount" :class="$style.navigation">
    <ul>
      <li
        :class="$style.navigationItem"
        @mouseenter="
          () => {
            if (isPc) {
              onMouseEnterNavigationPC('category');
            }
          }
        "
        @mouseleave="
          () => {
            if (isPc) {
              onMouseLeaveNavigationPC();
            }
          }
        "
        @click="
          () => {
            if (isSp) {
              onClickNavigationSP('category');
            }
          }
        "
      >
        <span>カテゴリー</span>
        <div v-show="currentModal === 'category'" :class="$style.modal">
          <div v-show="isSearchOpen" :class="$style.headerSearchFormWrap">
            <form action="/listing" :class="$style.headerSearchForm">
              <input ref="modalSearchRef" type="search" name="q" tabindex="1" placeholder="何をお探しですか？" :value="query" :class="$style.headerSearchQuery" />
              <button type="submit" :class="$style.headerSearchSubmit">
                <SvgIcon :svg="SearchIcon" width="20" aria-label="検索" />
              </button>
            </form>
            <div :class="$style.modalClose" @click.stop="onClickCloseSearchButton">
              <i class="icon-cross1"></i>
            </div>
          </div>
          <template v-if="currentModal === 'category'">
            <div :class="$style.headerCategoryTitleWrap">
              <div
                v-if="currentCategory"
                :class="$style.subCategoriesClose"
                @click.stop="
                  () => {
                    currentCategory = '';
                  }
                "
              >
                <i class="icon-arrow-left"></i>
              </div>
              <p>{{ currentCategory ? cats.find((cat) => cat.slug === currentCategory)!.name : 'カテゴリーから探す' }}</p>
              <div v-if="!isSearchOpen" :class="$style.modalClose" @click.stop="onClickCloseModalButton">
                <i class="icon-cross1"></i>
              </div>
            </div>
            <ul :class="$style.categories">
              <li
                v-for="cat in cats"
                :key="cat.slug"
                :class="[currentCategory === cat.slug && $style.isActive]"
                :data-category="cat.slug"
                @mouseenter="
                  () => {
                    if (isPc) {
                      onMouseEnterCategoryPC(cat.slug);
                    }
                  }
                "
                @mouseleave="
                  () => {
                    if (isPc) {
                      onMouseLeaveCategoryPC();
                    }
                  }
                "
                @click.stop="
                  () => {
                    onClickCategory(cat.slug);
                  }
                "
              >
                <template v-if="cat.slug !== 'others'">
                  <span>
                    {{ cat.name }}
                  </span>
                  <div :class="[$style.subCategories, isSearchOpen && $style.isSearchOpen]">
                    <ul>
                      <li>
                        <a :href="`/category/${cat.slug}`"> 全ての{{ cat.name }} </a>
                      </li>
                      <li v-for="subcat in subcats(cat.categoryId)" :key="subcat.slug" :class="`category-${subcat.slug}`">
                        <a :href="`/category/${cat.slug}/${subcat.slug}`">{{ subcat.name }}</a>
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <a :href="`/category/${cat.slug}`">{{ cat.name }}</a>
                </template>
              </li>
              <li data-category="vintage"><a :href="`/listing?vintage=on`">アンティーク・ヴィンテージ</a></li>
            </ul>
          </template>
        </div>
      </li>
      <li
        :class="$style.navigationItem"
        @mouseenter="
          () => {
            if (isPc) {
              onMouseEnterNavigationPC('contents');
            }
          }
        "
        @mouseleave="
          () => {
            if (isPc) {
              onMouseLeaveNavigationPC();
            }
          }
        "
        @click="
          () => {
            if (isSp) {
              onClickNavigationSP('contents');
            }
          }
        "
      >
        <a
          href="/contents"
          @click="
            (e) => {
              if (isSp) {
                e.preventDefault();
              }
            }
          "
          >読みもの</a
        >
        <div v-if="currentModal === 'contents'" :class="$style.modal">
          <div :class="$style.headerCategoryTitleWrap">
            <p>読みもの</p>
            <div :class="$style.modalClose" @click.stop="onClickCloseModalButton">
              <i class="icon-cross1"></i>
            </div>
          </div>
          <div :class="$style.contents">
            <ul>
              <li><a href="/contents">読みものトップ</a></li>
              <li><a href="/contents/articles">新着記事</a></li>
              <li><a href="/contents/series">シリーズ一覧</a></li>
            </ul>
            <dl>
              <dt>ピックアップ</dt>
              <dd v-for="series in seriesList.filter((series) => series.id === 'newsletter')" :key="series.id">
                <a :href="`/contents/series/${series.id}`">
                  <img v-if="series.image_header" :src="`${series.image_header.url}?fm=webp`" alt="" width="240" height="40" decoding="async" loading="lazy" />
                  <span v-else :class="$style.blank"></span>
                  <span :class="$style.name">{{ series.name }}</span></a
                >
              </dd>
              <dd>
                <a href="/special"><img src="https://cdn.iichi.com/site/images/menu/banner/contents/2022/03/featured.jpg" alt="" width="240" height="40" decoding="async" loading="lazy" /><span :class="$style.name">暮らしと手仕事</span></a>
              </dd>
              <dd>
                <a href="/contents/staff-coordinate"
                  ><img src="https://cdn.iichi.com/content-theme/I3969418/2/65004897e5be8.jpg" alt="" width="240" height="40" decoding="async" loading="lazy" /><span :class="$style.name">スタッフのおすすめコーディネート</span></a
                >
              </dd>
              <dd v-for="series in seriesList.filter((series) => series.id !== 'newsletter')" :key="series.id">
                <a :href="`/contents/series/${series.id}`">
                  <img v-if="series.image_header" :src="`${series.image_header.url}?fm=webp`" alt="" width="240" height="40" decoding="async" loading="lazy" />
                  <span v-else :class="$style.blank"></span>
                  <span :class="$style.name">{{ series.name }}</span></a
                >
              </dd>
            </dl>
          </div>
        </div>
      </li>
      <li :class="$style.navigationItem">
        <a href="/listing?vintage=on">アンティーク・ヴィンテージ</a>
      </li>
      <li :class="$style.navigationItem">
        <a href="/featured">人気のカテゴリーと作品</a>
      </li>
      <li :class="$style.navigationItem">
        <a href="/event">イベント情報</a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useMQ } from '@/js/lib/helper/media-query';
import { sleep } from '@/js/lib/helper/sleep';
import { categories } from '@/js/data/category';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import IichiLogo from '@/icon/vue/iichi-logo.svg';
import SearchIcon from '@/icon/vue/search.svg';
import HeaderIcons from './HeaderIcons.vue';

interface Series {
  id: string;
  name: string;
  image_header: {
    url: string;
  };
}

const props = withDefaults(
  defineProps<{
    initialQuery?: string;
    useH1?: boolean;
    isAccount?: boolean;
    isSimple?: boolean;
    seriesList?: Series[];
  }>(),
  {
    initialQuery: '',
    seriesList: () => [],
  },
);
const { isPc, isSp } = useMQ();
const modalSearchRef = ref<HTMLElement>();
const sethover = ref<number | undefined>(undefined);
const currentModal = ref('');
const currentCategory = ref('');
const query = ref('');
const isSearchOpen = ref(false);
const cats = computed(() => categories());
const subcats = computed(() => (categoryId: number) => categories({ parentCategoryId: categoryId }));
const openModal = (target: string) => {
  document.querySelector('body')?.classList.add('header-menu-open');
  currentModal.value = target;
};
const closeModal = () => {
  document.querySelector('body')?.classList.remove('header-menu-open');
  currentModal.value = '';
  currentCategory.value = '';
};
const onMouseEnterNavigationPC = (target: string) => {
  openModal(target);
};
const onMouseLeaveNavigationPC = () => {
  closeModal();
};
const onClickNavigationSP = (target: string) => {
  openModal(target);
};
const onMouseEnterCategoryPC = (slug: string) => {
  sethover.value = window.setTimeout(() => {
    currentCategory.value = slug;
  }, 300);
};
const onMouseLeaveCategoryPC = () => {
  clearTimeout(sethover.value);
};
const onClickCategory = (slug: string) => {
  currentCategory.value = slug;
};
const onClickCloseModalButton = () => {
  closeModal();
};
const onClickCloseSearchButton = () => {
  document.querySelector('body')?.classList.remove('header-menu-open');
  currentModal.value = '';
  currentCategory.value = '';
  isSearchOpen.value = false;
};
const onClickSearchInputSP = async () => {
  currentModal.value = 'category';
  isSearchOpen.value = true;
  await sleep(100);
  modalSearchRef.value?.focus();
  document.querySelector('body')?.classList.add('header-menu-open');
};
const onSubmitSearch = () => {
  if (query.value) {
    window.dataLayer?.push({
      event: 'search',
      search_term: query.value,
    });
  }
};

onMounted(() => {
  query.value = props.initialQuery;
});
</script>

<style module lang="scss">
@keyframes modal-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.header {
  padding: 28px 0 4px;

  @media (--sp) {
    padding: 10px 10px 2px;
    position: relative;

    :global(.header-menu-open) & {
      z-index: 1000;
    }
  }

  a:hover {
    text-decoration: none;
  }
}

.headerSearchForm {
  position: relative;
  width: 400px;

  @media (--sp) {
    width: auto;
  }

  .headerSearchQuery {
    border: 1px solid $border-color;
    border-radius: 4px;
    height: 38px;
    line-height: 34px;
    margin: 0;
    padding: 0 36px 0 8px;
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  .headerSearchSubmit {
    align-items: center;
    border: none;
    display: flex;
    height: 38px;
    padding: 0 10px;
    position: absolute;
    right: 0;
    top: 0;

    svg {
      fill: #999;
    }
  }
}

.headerMain {
  display: grid;
  grid-template-areas: 'logo search icons';
  grid-template-columns: 130px 1fr 1fr;

  @media (--sp) {
    grid-template-areas:
      'logo icons'
      'search search';
    grid-template-columns: initial;
  }

  .headerLogo {
    grid-area: logo;

    @media (--sp) {
      padding: 5px 2px 0;
    }

    svg {
      @media (--sp) {
        width: 58px;
      }
    }
  }

  .headerSearch {
    border-radius: 5px;
    grid-area: search;
    justify-self: flex-start;

    @media (--sp) {
      justify-self: initial;
      margin: 8px 0 0;
    }
  }
}

.navigation {
  position: relative;
  text-align: center;

  @media (--sp) {
    :global(.header-menu-open) & {
      z-index: 1001;
    }

    :global(.hide-navigation) & {
      display: none;
    }

    :global(.header-menu-open) :global(.hide-navigation) & {
      display: block;

      > ul > li {
        > span,
        > a {
          display: none;
        }
      }
    }
  }

  > ul {
    display: flex;
    margin: 0 auto;
    text-align: left;

    @media (--sp) {
      overflow-x: auto;
      white-space: nowrap;
      width: auto;
    }
  }

  .navigationItem {
    > a,
    > span {
      color: $gray900;
      cursor: pointer;
      display: block;
      height: 48px;
      line-height: 48px;
      padding: 0 17px;
      text-align: center;

      @media (--sp) {
        padding: 0 10px;
      }
    }

    > a {
      &:hover {
        text-decoration: none;
      }

      > span {
        color: $dark-red;
        font-size: 10px;
        padding: 2px 4px;
      }
    }

    > span {
      @media (--sp) {
        pointer-events: none;
      }
    }
  }
}

.modal {
  background-color: var(--color-white);
  display: flex;
  left: -100%;
  opacity: 0;
  position: absolute;
  top: 48px;
  z-index: 1002;

  @media (--sp) {
    flex-direction: column;
    height: 100%;
    position: fixed;
    top: 0;
    width: 100%;
  }

  .modalClose {
    > i {
      cursor: pointer;
      display: block;
      font-size: 24px;
      margin: -5px -10px -5px 0;
      padding: 12px;
    }
  }

  .headerSearchFormWrap {
    display: none;
    justify-content: flex-end;
    padding: 10px;

    @media (--sp) {
      border-bottom: $gray200 1px solid;
      display: flex;
    }

    .headerSearchForm {
      flex: 1;
    }
  }

  .headerCategoryTitleWrap {
    display: none;
    justify-content: space-between;
    padding: 12px;
    position: relative;
    text-align: center;

    @media (--sp) {
      display: block;
    }

    p {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0;
    }

    .subCategoriesClose {
      cursor: pointer;
      left: 2px;
      position: absolute;
      top: 6px;

      > i {
        font-size: 36px;
      }
    }

    .modalClose {
      position: absolute;
      right: 0;
      top: 0;

      > i {
        margin: 0;
      }
    }
  }

  > .categories {
    background-color: var(--color-white);
    padding: 5px 0 5px 5px;
    width: 320px;

    @media (--sp) {
      flex: 1;
      margin-top: 0;
      overflow: hidden scroll;
      padding: 0 0 5px 5px;
      position: relative;
      width: 100%;
    }

    &:has(.isActive) {
      @media (--sp) {
        overflow-y: hidden;
      }
    }

    > li {
      @media (--sp) {
        position: static;
      }

      > a,
      > span {
        color: inherit;
        cursor: pointer;
        display: block;
        height: 52px;
        line-height: 26px;
        padding: 13px 13px 13px 55px;
        position: relative;
        text-decoration: none;

        @media (--sp) {
          font-size: 16px;
          padding-left: 57px;
        }

        &:hover {
          background: $gray100;
        }

        &::before {
          background-repeat: no-repeat;
          background-size: 40px;
          border: 1px solid #e7e7e7;
          color: #e7e7e7;
          content: ' ';
          height: 42px;
          left: 5px;
          position: absolute;
          top: 5px;
          width: 42px;
        }

        &::after {
          color: var(--color-black);
          content: $icon-arrow-right;
          font-family: $font-icon;
          font-size: 28px;
          line-height: 1;
          position: absolute;
          right: 5px;
          top: 10px;

          @media (--sp) {
            right: 10px;
          }
        }
      }

      &[data-category='accessories'] > span::before {
        background-image: url('@/images/icons/category-accessories.jpg');
      }

      &[data-category='clothing'] > span::before {
        background-image: url('@/images/icons/category-clothing.jpg');
      }

      &[data-category='bag_case'] > span::before {
        background-image: url('@/images/icons/category-bag_case.jpg');
      }

      &[data-category='kitchenware'] > span::before {
        background-image: url('@/images/icons/category-kitchenware.jpg');
      }

      &[data-category='houseware'] > span::before {
        background-image: url('@/images/icons/category-houseware.jpg');
      }

      &[data-category='miscellaneous-goods'] > span::before {
        background-image: url('@/images/icons/category-miscellaneous-goods.jpg');
      }

      &[data-category='art'] > span::before {
        background-image: url('@/images/icons/category-art.jpg');
      }

      &[data-category='kids_baby'] > span::before {
        background-image: url('@/images/icons/category-kids_baby.jpg');
      }

      &[data-category='doll_toy'] > span::before {
        background-image: url('@/images/icons/category-doll_toy.jpg');
      }

      &[data-category='tools_supplies'] > span::before {
        background-image: url('@/images/icons/category-tools_supplies.jpg');
      }

      &[data-category='food'] > span::before {
        background-image: url('@/images/icons/category-food.jpg');
      }

      &[data-category='others'] > a {
        &::before {
          background-image: url('@/images/icons/category-others.jpg');
        }

        &::after {
          display: none;
        }
      }

      &[data-category='vintage'] > a {
        &::before {
          background-image: url('@/images/icons/category-vintage.jpg');
        }

        &::after {
          display: none;
        }
      }

      .subCategories {
        background-color: var(--color-white);
        display: none;
        height: 686px;
        left: 100%;
        padding: 10px;
        position: absolute;
        top: 0;
        width: 300px;

        @media (--sp) {
          bottom: 0;
          display: block;
          height: calc(100vh - 48px);
          height: calc(100dvh - 48px);
          overflow-y: auto;
          position: fixed;
          top: initial;
          transition: left 0.2s;
          width: 100% !important;
          z-index: 1;

          &.isSearchOpen {
            height: calc(100vh - 107px);
            height: calc(100dvh - 107px);
          }
        }

        a {
          display: block;
          line-height: 26px;
          padding: 7px 6px;

          @media (--sp) {
            font-size: 16px;
          }

          &:hover {
            background: $gray100;
            text-decoration: none;
          }
        }

        > ul {
          display: flex;
          flex-flow: column wrap;
          height: 100%;
          margin-top: 0;

          @media (--sp) {
            flex-flow: column;
          }

          > li {
            &:first-child {
              @media (--pc) {
                font-weight: bold;
              }
            }

            &:last-child {
              @media (--sp) {
                padding-bottom: 10px;
              }
            }
          }
        }
      }

      &[data-category='accessories'] .subCategories,
      &[data-category='bag_case'] .subCategories,
      &[data-category='houseware'] .subCategories,
      &[data-category='miscellaneous-goods'] .subCategories,
      &[data-category='food'] .subCategories {
        width: 520px;
      }

      &:hover .subCategories {
        @media (--pc) {
          display: block;
        }
      }

      &.isActive .subCategories {
        @media (--sp) {
          left: 0;
        }
      }
    }
  }

  > .contents {
    padding: 10px;
    width: 268px;

    @media (--sp) {
      overflow: hidden scroll;
      width: auto;
    }

    > ul {
      padding-bottom: 15px;

      > li {
        > a {
          display: block;
          line-height: 26px;
          padding: 7px 6px;

          @media (--sp) {
            font-size: 16px;
          }

          &:hover {
            background: $gray100;
            text-decoration: none;
          }
        }
      }
    }

    > dl {
      text-align: center;

      > dt {
        display: inline-block;
        padding: 0 30px;
        position: relative;

        @media (--pc) {
          font-size: 12px;
        }

        &::before,
        &::after {
          background-color: var(--color-black);
          content: '';
          display: inline-block;
          height: 1px;
          position: absolute;
          top: 50%;
          width: 24px;
        }

        &::before {
          left: 0;
        }

        &::after {
          right: 0;
        }
      }

      > dd {
        margin: 10px 0 0;
        text-align: left;

        &:first-of-type {
          margin: 8px 0 0;
        }

        > a {
          display: block;
          position: relative;

          > img {
            border-radius: 2px;
            height: auto;
            vertical-align: bottom;
            width: 100%;
          }

          .blank {
            aspect-ratio: 6 / 1;
            background-color: $gray300;
            display: block;
          }

          .name {
            align-items: center;
            background-color: rgb(75 75 75 / 40%);
            border-radius: 2px;
            color: var(--color-white);
            display: flex;
            font-family: var(--font-yu-gothic);
            font-weight: bold;
            height: 100%;
            left: 0;
            padding: 10px 12px;
            position: absolute;
            top: 0;
            transition: background-color 0.2s;
            width: 100%;
          }

          &:hover .name {
            background-color: rgb(75 75 75 / 0%);
            text-shadow: 0 0 3px var(--color-black-alpha40);
          }
        }
      }
    }
  }

  @media (--pc) {
    .navigationItem:hover & {
      animation: modal-fade-in 0.15s ease-in 0s forwards;
      left: 0;
    }
  }

  @media (--sp) {
    :global(.header-menu-open) & {
      animation: modal-fade-in 0.15s ease-in 0s forwards;
      left: 0;
    }
  }
}
</style>
